import { render, staticRenderFns } from "./page-sign-in.vue?vue&type=template&id=33f5ae20&scoped=true"
import script from "./page-sign-in.vue?vue&type=script&lang=js"
export * from "./page-sign-in.vue?vue&type=script&lang=js"
import style0 from "./page-sign-in.vue?vue&type=style&index=0&id=33f5ae20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f5ae20",
  null
  
)

export default component.exports